export default __webpack_public_path__ + "static/media/Vector (6).b7aa1b84.svg";